import React from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars-2';

import Button from 'app/common/ui/Button';
import { fetchPolls } from '../../../../actions/fund/polls';
import { getIsMember } from '../../../../selectors/user';
import { getPollsKeys } from '../../../../selectors/fund/polls';
import Cactus from '../../../_Icons/Cactus';
import IconLoaderClock from '../../../_Icons/IconLoaderClock';
import PollItem from '../PollItem';
import config from '../../../../config';
import styles from './Polls.scss';


const cx = classNames.bind(styles);

// const propTypes = {
//   params: React.PropTypes.shape({
//     schoolId: React.PropTypes.string,
//     pollId: React.PropTypes.string,
//     type: React.PropTypes.string,
//   }).isRequired,
//   location: React.PropTypes.shape({
//     pathname: React.PropTypes.string.isRequired,
//   }),
//   pollsKeys: React.PropTypes.array.isRequired,
//   pollsData: React.PropTypes.object.isRequired,
//   actions: React.PropTypes.shape({
//     fetchPolls: React.PropTypes.func.isRequired,
//   }),
//   isMember: React.PropTypes.bool,
//   loading: React.PropTypes.bool,
//   didInvalidate: React.PropTypes.bool,
//   children: React.PropTypes.element,
// };

const defaultProps = {
};

/**
* Компонент страницы со списком опросов
*/
class Polls extends React.Component {
  componentDidMount() {
    const { actions, params: { schoolId } } = this.props;
    window.scrollTo(0, 0); // Вверх страницы
    if (parseInt(schoolId, 10)) {
      actions.fetchPolls(schoolId);
    }
    this.fetchPollsLoop();
  }

  // $FlowFixMe
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { actions, params: { schoolId } } = this.props;
    const newId = nextProps.params.schoolId;
    if ((schoolId !== newId) && parseInt(newId, 10)) {
      actions.fetchPolls(newId);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize, true);
    this.stopPollsLoop();
  }

  fetchPollsLoop = () => {
    const { updateInterval } = config;
    this.interval = setInterval(
      () => {
        const { actions, params: { schoolId } } = this.props;
        if (parseInt(schoolId, 10)) {
          actions.fetchPolls(schoolId);
        }
      }, updateInterval);
  }

  stopPollsLoop = () => {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  renderList = () => {
    const {
      location: { pathname },
      pollsKeys,
      pollsData,
    } = this.props;

    const isEmpty = !pollsKeys.length;
    if (isEmpty) {
      return (
        <div className={cx({ list: true, empty: isEmpty })}>
          <div><Cactus className={styles.cactus} /></div>
        </div>
      );
    }
    const url = pathname.split('/').slice(0, 5);
    const basePath = url.join('/');
    return (
      <Scrollbars className={styles.list}>
        {pollsKeys.map(key => (
          <PollItem
            key={key}
            id={key}
            title={pollsData[key].title}
            endsAt={pollsData[key].endsAt}
            status={pollsData[key].status}
            basePath={basePath}
          />
        ))}
      </Scrollbars>
    );
  }

  render() {
    const {
      children,
      isMember,
      params: { schoolId, pollId, type },
      loading,
      didInvalidate,
    } = this.props;
    const isLoading = loading && didInvalidate;
    const buttonText = isMember
      ? 'Создать опрос'
      : 'Создавать опросы могут только члены родительского комитета';

    return (
      <div className={styles.root}>

        <div className={styles.leftBar}>
          { /* Кнопка нового голосования */ }
          {type === 'mypolls'
            && <Button
              className={styles.add}
              href={`/app/${schoolId}/fund/mypolls/new`}
              disabled={!isMember}
            >
              {buttonText}
            </Button>}
          { /* Список голосований */ }
          {isLoading
            ?
              <div className={cx({ list: true, loading: isLoading })}>
                <IconLoaderClock className={styles.clock} />
              </div>
            : this.renderList()}
          {pollId === 'new' && <div className={styles.lock} />}
        </div>

        <div className={styles.rightBar}>
          {isLoading
            ? <IconLoaderClock className={styles.clock} />
            : children}
        </div>
      </div>
    );
  }
}

// Polls.propTypes = propTypes;
Polls.defaultProps = defaultProps;


const mapStateToProps = (store, ownProps) => {
  const { params: { schoolId, type } } = ownProps;
  const isOned = (type === 'mypolls');
  return ({
    isMember: getIsMember(store, schoolId),
    pollsKeys: getPollsKeys(store, isOned),
    pollsData: store.fund.polls.data,
    loading: store.fund.polls.loading,
    didInvalidate: store.fund.polls.didInvalidate,
  });
};

const mapDispatchToProps = dispatch => ({
  actions: {
    fetchPolls: id => dispatch(fetchPolls(id)),
  },
});


export default connect(mapStateToProps, mapDispatchToProps)(Polls);
